export default "__VITE_ASSET__45293f92__"